import React from 'react';
import { useSelector } from 'react-redux';
import uniqBy from 'lodash/uniqBy';
import isEmpty from 'lodash/isEmpty';
import BecauseYouShopped from 'core/modules/BecauseYouShopped/BecauseYouShopped';
import ForYouSignIn from 'core/modules/ForYouSignIn/ForYouSignIn';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectRecentMemberOrdersRecords } from 'core/modules/RecentMemberOrders/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectActiveMQ } from 'core/modules/MediaQueries/selectors';

import config from './configs';

import './ForYouBecauseYouShoppedList.scss';

function ForYouBecauseYouShoppedList() {
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const recentMemberOrders = useSelector(selectRecentMemberOrdersRecords);
  const activeMQ = useSelector(selectActiveMQ);

  const { checkShouldUseCarousel } = config;
  const shouldUseCarousel = checkShouldUseCarousel(activeMQ);

  /*
    Returns at most 2 merchants to display on For You page
    "Because you shopped at merchant 1"
    "Because you shopped at merchant 2"
    Should prioritize most recent merchants with purchases and then most recent merchants with clicks
    member-orders API call should return sorted by date.
    Loops through all results to find any purchases and separates member orders with and without purchases.
  */
  const getMerchantsForMatching = () => {
    const merchantsWithPurchases = [];
    const merchantsWithClicks = [];
    for (let i = 0; i < recentMemberOrders.length; i += 1) {
      const memberOrder = recentMemberOrders[i];
      const merchant = {
        merchantId: memberOrder.globalMerchantId,
        merchantName: memberOrder.merchantName,
      };

      if (isEmpty(memberOrder.orders)) {
        merchantsWithClicks.push(merchant);
      } else {
        merchantsWithPurchases.push(merchant);
      }
    }

    return uniqBy([...merchantsWithPurchases, ...merchantsWithClicks], 'merchantId').slice(0, 10);
  };

  if (!userIsIdentified) {
    return (
      <div className="mn_forYouBecauseYouShoppedList mn_anonymous">
        <SectionTitle title="Because you shopped at" />
        <ForYouSignIn title="Sign in for personalized recommendations." />
      </div>
    );
  }

  if (isEmpty(recentMemberOrders)) {
    return null;
  }

  const merchantsForMatching = getMerchantsForMatching();

  if (isEmpty(merchantsForMatching)) {
    return null;
  }

  return (
    <div className="mn_forYouBecauseYouShoppedList">
      {merchantsForMatching.map(merchantForMatching => (
        <BecauseYouShopped
          key={merchantForMatching.merchantId}
          {...merchantForMatching}
          useCarousel={shouldUseCarousel}
        />
      ))}
    </div>
  );
}

export default (props) =>
  <ComponentErrorBoundary><ForYouBecauseYouShoppedList {...props} /></ComponentErrorBoundary>;
